import { Reikwijdte, Traject } from "@/entities/dossier-details";
import { capitalizeFirstChar } from "@/shared/utils";

export function getReikwijdteLabel(reikwijdte: Reikwijdte, stations: string[], trajecten: Traject[]) {
    switch (reikwijdte) {
        case "Stations":
            return stations.map((s) => capitalizeFirstChar(s)).join(", ");
        case "Trajecten":
            return Traject.format(trajecten);
        case "Landelijk":
            return "Landelijk";
    }
}
